<template>
  <div />
</template>

<script>
export default {
  props: {
    src: { // 资源地址
      type: String,
      default: ''
    },
    scriptKey: { // 唯一标识
      type: String,
      default: ''
    }
  },

  mounted() {
    // desc：按需加载js文件

    let scriptEl = document.querySelector(`script[scriptKey='${this.scriptKey}']`)

    if(!scriptEl){
        const s = document.createElement('script')

        s.type = 'text/javascript'

        s.src = this.src

        s.setAttribute('scriptKey',this.scriptKey)

        document.body.appendChild(s)

        s.onload = ()=>{
          console.log(this.scriptKey,document.readyState)
            if(['interactive','complete'].includes(document.readyState)){     // 已加载；加载完成
                this.$emit('loadComplete',true)
            }
        }
    }

  }
}
</script>

<style>

</style>
